<template>
  <!-- 特卖评价 -->
  <div class="sale_common">
    <div class="sale_common_main">
      <!-- 评价 -->
      <div class="sale_common_title">
        <!-- 标题 -->
        <h3>
          <p></p>常见问题
        </h3>
        <!-- 星 -->
        <p>***************************************************************************************************************************************************************************************************************************************************************</p>
      </div>
      <div class="sale_common_problem">
          <!-- 问题-->
        <div class="answer_person">
          <div class="answer_con">
            <div class="answer_question">
              <p>马桶购买需要注意什么？</p>
            </div>
            <!-- 问题答案 -->
            <div class="ans_content">
              <p>
                <i>精华</i>1.购买前要测量墙距，即墙至水下口中心的距离，根据墙距选择适合的马桶。一般来说，马桶的排水口分为前后两种，称为前出水马桶和后出水马桶。
              </p>
              <p>2.注意挑选瓷质，瓷质细腻，釉面光洁致密的马桶，水和污垢不易渗入，容易冲净，既美观又 便于清洁。</p>
              <p>3.购买前要测量墙距，即墙至水下口中心的距离，根据墙距选择适合的马桶。一般来说，马桶的排水口分为前后两种，称为前出水马桶和后出</p>
            </div>
            <!-- 回答、收藏-->
            <div class="ans_praise">
              <span>
                <img src="../../assets/img/bicon04.png" alt>
                <p>回答</p>10
              </span>
              <span>
                <img src="../../assets/img/bicon08.png" alt>
                <p>取消收藏</p>10
              </span>
            </div>
          </div>
          <div class="answer_con">
            <div class="answer_question">
              <p>马桶购买需要注意什么？</p>
            </div>
            <!-- 问题答案 -->
            <div class="ans_content">
              <p>
                <i>精华</i>1.购买前要测量墙距，即墙至水下口中心的距离，根据墙距选择适合的马桶。一般来说，马桶的排水口分为前后两种，称为前出水马桶和后出水马桶。
              </p>
              <p>2.注意挑选瓷质，瓷质细腻，釉面光洁致密的马桶，水和污垢不易渗入，容易冲净，既美观又 便于清洁。</p>
              <p>3.购买前要测量墙距，即墙至水下口中心的距离，根据墙距选择适合的马桶。一般来说，马桶的排水口分为前后两种，称为前出水马桶和后出</p>
            </div>
            <!-- 回答、收藏-->
            <div class="ans_praise">
              <span>
                <img src="../../assets/img/bicon04.png" alt>
                <p>回答</p>10
              </span>
              <span>
                <img src="../../assets/img/bicon08.png" alt>
                <p>收藏</p>10
              </span>
            </div>
          </div>
          <div class="answer_con">
            <div class="answer_question">
              <p>马桶购买需要注意什么？</p>
            </div>
            <!-- 问题答案 -->
            <div class="ans_content">
              <p>
                <i>精华</i>1.购买前要测量墙距，即墙至水下口中心的距离，根据墙距选择适合的马桶。一般来说，马桶的排水口分为前后两种，称为前出水马桶和后出水马桶。
              </p>
              <p>2.注意挑选瓷质，瓷质细腻，釉面光洁致密的马桶，水和污垢不易渗入，容易冲净，既美观又 便于清洁。</p>
              <p>3.购买前要测量墙距，即墙至水下口中心的距离，根据墙距选择适合的马桶。一般来说，马桶的排水口分为前后两种，称为前出水马桶和后出</p>
            </div>
            <!-- 回答、收藏-->
            <div class="ans_praise">
              <span>
                <img src="../../assets/img/bicon04.png" alt>
                <p>回答</p>10
              </span>
              <span>
                <img src="../../assets/img/bicon08.png" alt>
                <p>取消收藏</p>10
              </span>
            </div>
          </div>
          <div class="answer_con">
            <div class="answer_question">
              <p>马桶购买需要注意什么？</p>
            </div>
            <!-- 问题答案 -->
            <div class="ans_content">
              <p>
                <i>精华</i>1.购买前要测量墙距，即墙至水下口中心的距离，根据墙距选择适合的马桶。一般来说，马桶的排水口分为前后两种，称为前出水马桶和后出水马桶。
              </p>
              <p>2.注意挑选瓷质，瓷质细腻，釉面光洁致密的马桶，水和污垢不易渗入，容易冲净，既美观又 便于清洁。</p>
              <p>3.购买前要测量墙距，即墙至水下口中心的距离，根据墙距选择适合的马桶。一般来说，马桶的排水口分为前后两种，称为前出水马桶和后出</p>
            </div>
            <!-- 回答、收藏-->
            <div class="ans_praise">
              <span>
                <img src="../../assets/img/bicon04.png" alt>
                <p>回答</p>10
              </span>
              <span>
                <img src="../../assets/img/bicon08.png" alt>
                <p>取消收藏</p>10
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "sale-common",
  data() {
    return {
      value: 3
    };
  }
};
</script>
<style scoped>
.sale_common {
  width: 1200px;
  background: #fff;
  margin-left:20px
}
.sale_common_main {
  width: 1200px;
  margin: 0 auto;
}
/* 评价 */
.sale_common_main .sale_common_title {
  /* height: 410px; */
  margin-top: 25px;
}
/* 评价标题 */
.sale_common_title h3 {
  color: rgba(51, 51, 51, 1);
  text-align: left;
  font-size: 21px;
  margin-bottom: 10px;
}
.sale_common_title h3 p {
  display: inline-block;
  width: 4px;
  height: 21px;
  background: rgba(222, 7, 22, 1);
  margin-bottom: -4px;
  margin-right: 10px;
}
/* 星 */
.sale_common_title p {
  color: rgba(237, 237, 237, 1);
}
/* 常见问题 */
.sale_common_problem{
    margin-bottom:20px
}
/* 提出的问题 */
.sale_common_problem .answer_question {
  width: 1160px;
  height: 95px;
  text-align: left;
  line-height: 95px;
  font-size: 20px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-left: 40px;
}
/* 回复的具体信息 */
.sale_common_problem .answer_person .answer_con {
  width: 1200px;
  height: 235px;
  margin-top: 20px;
  background: rgba(248, 248, 248, 1);
}

/* 问题答案 */
.sale_common_problem  .answer_con .ans_content p {
  text-align: left;
  font-size: 14px;
 
  font-weight: 400;
  color: rgba(85, 85, 85, 1);
  line-height: 22px;
  margin:0 0 0 40px;
}
/* 精华 */
.sale_common_problem  .answer_con .ans_content p i {
  width: 38px;
  height: 18px;
  display: inline-block;
  background: rgba(255, 153, 0, 1);
  border-radius: 2px;
  line-height: 18px;
  text-align: center;
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  margin-right: 6px;
}
/* 回答、收藏*/
.sale_common_problem  .answer_con .ans_praise span {
  float: left;
  font-size: 14px;
  margin-top: 11px;
  margin-left: 40px;
}
.sale_common_problem  .answer_con .ans_praise img,
.sale_common_problem  .answer_con .ans_praise p {
  float: left;
  margin:0 8px 0 0;
  font-size: 14px;
 
  font-weight: 400;
  color: rgba(136, 136, 136, 1);
  line-height: 14px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// saleCommonProblem.vue?665c4746